import Icon from "@material-ui/icons/SpeakerNotesOff";
import ExcludeBusAssistantList from "./ExcludeBusAssistantList";
import ExcludeBusAssistantCreate from "./ExcludeBusAssistantCreate";
import ExcludeBusAssistantEdit from "./ExcludeBusAssistantEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "excludeBusAssistants",
  list: ExcludeBusAssistantList,
  create: ExcludeBusAssistantCreate,
  edit: ExcludeBusAssistantEdit,
  icon: Icon,
};
